import React from "react";
import { TextField, InputAdornment } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

// label rendered as a static block above the field instead of the default notched/floating label
const labelSx = {
  position: "static",
  transform: "none",
  fontFamily: "inherit",
  fontSize: "14px",
  fontWeight: 500,
  color: "#1a1a2e",
  marginBottom: "6px",
  "& .MuiFormLabel-asterisk": { color: "#e5254e" },
  "&.Mui-disabled": { color: "#a0a0ab" },
};

const inputSx = {
  borderRadius: "8px",
  backgroundColor: "#fff",
  fontFamily: "inherit",
  "& input": {
    fontFamily: "inherit",
    fontSize: "14px",
    height: "100%",
    padding: "0 10px",
    boxSizing: "border-box",
    caretColor: "#000",
    fontWeight: 400,
  },
  "& input:not(:placeholder-shown)": { fontWeight: 600 },
  "& input::placeholder": { color: "#9a9aa8", opacity: 1 },
  "& input::-webkit-search-cancel-button": { display: "none" },
  "& input::-ms-clear": { display: "none" },
  "& .MuiInputBase-inputAdornedEnd": { paddingRight: 0 },
  "& .MuiInputAdornment-positionEnd": { marginLeft: "4px", marginRight: 0 },
  "&.MuiInputBase-adornedEnd": { paddingRight: "4px" },
  transition: "box-shadow 100ms ease-out",
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#E2E2E3",
    transition: "border-color 100ms ease-out, border-width 100ms ease-out",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#AEB0B2" },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#185CFB",
    borderWidth: "2px",
  },
  "&.Mui-error .MuiOutlinedInput-notchedOutline": { borderColor: "#e5254e" },
  "&.Mui-disabled": { backgroundColor: "#f4f4f7" },
  "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
    borderColor: "#e2e2e8",
  },
};

const helperTextSx = {
  marginLeft: 0,
  display: "flex",
  alignItems: "center",
  fontFamily: "inherit",
  color: "#7a7a85",
  "&.Mui-error": { color: "#e5254e" },
  "&.Mui-disabled": { color: "#b5b5bf" },
};

const errorIconSx = { fontSize: 14, verticalAlign: "text-bottom", mr: 0.5 };

const TextInput = ({
  endAdornment,
  sx,
  InputProps,
  InputLabelProps,
  FormHelperTextProps,
  error,
  helperText,
  width = "100%",
  height = "40px",
  ...props
}) => (
  <TextField
    variant="outlined"
    error={error}
    helperText={
      error && helperText ? (
        <>
          <ErrorOutlineIcon sx={errorIconSx} />
          {helperText}
        </>
      ) : (
        helperText
      )
    }
    InputLabelProps={{ shrink: true, sx: labelSx, ...InputLabelProps }}
    InputProps={{
      endAdornment: endAdornment && (
        <InputAdornment position="end">{endAdornment}</InputAdornment>
      ),
      sx: { ...inputSx, height },
      ...InputProps,
    }}
    FormHelperTextProps={{ sx: helperTextSx, ...FormHelperTextProps }}
    sx={{ width, ...sx }}
    {...props}
  />
);

export default TextInput;
